import { connect } from 'react-redux';
import { getDivisionId } from 'redux-core/productions/selectors';

const mapStateToProps = (state) => ({
  divisionId: getDivisionId(state),
});

export default connect(mapStateToProps);
